import * as React from 'react';
import { vars, mixin, css, classNames } from '@src/services/theme';

// style
const style = css`
  height: 20px;
  width: 20px;
  display: inline-block;
  position: relative;
  border-radius: 50%;
  border: 4px solid lightblue;
  border-color: #1e70c9 lightblue;
  box-sizing: border-box;
  animation: loading 0.7s linear infinite;

@keyframes loading {
  0% {
      transform:rotate(0deg);
  } 100% {
      transform:rotate(360deg);
    }
}`;

// component
export default class LoadingMini extends React.Component {

	render() {
		return (
			<div className={style} />
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/UI/LoadingMini.tsx